import { Component, Input, OnInit } from '@angular/core';
import { ImportService } from '@services/imports/import.service';
import { ServerHealthService } from '@services/server-health/server-health.service';
import { PackageService } from '@services/packages/package.service';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';

@Component({
    selector: 'message-bubble',
    templateUrl: './message-bubble.component.html',
    styleUrls: ['./message-bubble.component.scss'],
    providers: [ImportService, PipeImportService, ServerHealthService, PackageService],
    standalone: false
})
export class MessageBubbleComponent implements OnInit {

  @Input() dataProvider;

  @Input() dataProviderName: string;

  @Input() dataProviderParams: any = {};

  @Input() dataFunctionName: string;

  public isLoading = false;

  public total = 0;

  public text: string = null;

  constructor(
    public importService: ImportService,
    public pipeImportService: PipeImportService,
    public serverHealthService: ServerHealthService,
    public packageService: PackageService
  ) {
  }

  ngOnInit() {
    if (this.dataProviderName === 'ImportService') {
      this.dataProvider = this.importService;
    }
    if (this.dataProviderName === 'PackageService') {
      this.dataProvider = this.packageService;
    }
    if (this.dataProviderName === 'PipeImportService') {
      this.dataProvider = this.pipeImportService;
    }
    if (this.dataFunctionName === 'getPageCount()') { // Counts Failed Imports
      this.getPageCount();
    }
    if (this.dataProviderName === 'ServerHealthService') {
      this.dataProvider = this.serverHealthService;
    }
    if (this.dataFunctionName === 'getLostServers()') { // Counts Servers with Errors
      this.getLostServers();
    }
  }

  public getPageCount() {
    if (!this.dataProvider || !this.dataProviderParams) {
      console.error('data provider or params are not defined!');
      return;
    }
    if (!this.total) {
      this.isLoading = true;
    }
    return this.dataProvider.find(0, 1, this.dataProviderParams).then(response => {
      this.total = response.total;
      this.isLoading = false;
      setTimeout(() => {
        this.getPageCount()
      }, 5000);
    });
  }

  public getLostServers() {
    this.isLoading = true;
    return this.dataProvider.find(0, 100, {}).then(response => {
      const now = new Date();
      const lostServers = response.data.filter(server => {
        return now.getTime() - server.lastSeen.getTime() > 1000 * 60 * 5;
      });
      this.total = lostServers.length;
      this.text = 'Warnings';
      this.isLoading = false;
    });
  }

}
